

const state = {
    
    blocks:[
        {
            id:1,
            name: 'Tags',
            color: '#fff',   
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formdatatable',
                            attributes: {
                                placeholder:"Tags",
                                size:"xs10",
                                invertedsize:"xs1",                                
                                icon:"search",                                
                                setter: 'tags/TAG_SET_TAG',                                    
                                items:'tags/tags',
                                withcheck:false,
                                withsearch:true,
                                withdialog:false,
                                headers: [
                                    {
                                        text: 'Name',
                                        value: 'name',
                                        sortable:false
                                    },    
                                    {
                                        text: 'Kategorie',
                                        value: 'tagcategories',
                                        sortable:false
                                    }, 
                                ]
                            }                                    
                        }
                    ],                   
                ]
            },
        },
        
    ]
    
};

export default {
  namespaced: false,
  state,
  
};